import { DumpListSort, ExportFolder } from './types';

const date = (s: string) => new Date(s).getTime() || 0;

export const dumpsListSorters: Record<DumpListSort, (a: ExportFolder, b: ExportFolder) => number> = {
  [DumpListSort.DATE_DESC]: (a, b) => date(b.createdAt) - date(a.createdAt),
  [DumpListSort.DATE_ASC]: (a, b) => date(a.createdAt) - date(b.createdAt),
  [DumpListSort.NAME_ASC]: (a, b) => a.name.localeCompare(b.name),
  [DumpListSort.NAME_DESC]: (a, b) => b.name.localeCompare(a.name),
};
